

































































































































































































import Vue, { PropType } from 'vue'
import { BatchLink } from './MBatchBuilder.vue'
import { countryCodes } from '@/countryCodes'

type Data = {
  countryCodes: { label: string; value?: string; disabled?: boolean; }[];
  cookieTypes: { value: string | null; label: string; }[];
  editing: boolean;
  advancedOptionsVisible: boolean;
}

export default Vue.extend({
  
  props: {
    link: {
      type: Object as PropType<BatchLink>,
      required: true,
    }
  },

  data(): Data {
    return {
      countryCodes,
      cookieTypes: [
        {
          value: null,
          label: 'None',
        },
        {
          value: '1',
          label: 'ANI'
        },
        {
          value: '3',
          label: 'Wildcard'
        }
      ],
      editing: false,
      advancedOptionsVisible: false,
    }
  },

  methods: {

    saveLink() {
      this.advancedOptionsVisible = false
      this.editing = false
      this.$emit('save-link')
    },

    deleteLink() {
      if (confirm('Are you sure you want to delete this link?')) {
        this.$emit('delete-link')
      }
    },

    editLink() {
      this.editing = true
    },

    toggleLinkAdvancedOptions() {
      this.advancedOptionsVisible = ! this.advancedOptionsVisible
    },

  },

  beforeMount() {
    this.editing = !! this.link.editing
  },

})
